import React from "react";
import Link from "next/link";
import Image from "next/image";
import { ssURL } from "client/clientAxios";

const SideBarUjian = ({ activeMenu }) => {
  return (
    <>
      <ul className="nav side-nav-ss side-nav-ujian bg-white rounded-ss px-3 py-4 flex-column">
        <li className="nav-item">
          <Link
            href={`${ssURL}/ujian`}
            className={`nav-link ${activeMenu == `${ssURL}/ujian` && "active"
              } color-dark fw-bold fs-18-ss d-flex align-items-center px-4 mb-3`}
            aria-current="page">
            <Image
              src={`/img/icon-nav-daftar-ujian.svg`}
              alt=""
              className="me-2"
              width={0}
              height={0}
              unoptimized
              priority
              style={{ width: 'auto', height: "auto" }}
            />
            Bank Soal
          </Link>
        </li>
        <li className="nav-item">
          <Link
            href={`${ssURL}/jadwal-ujian`}
            className={`nav-link ${activeMenu == `${ssURL}/jadwal-ujian` && "active"
              } color-dark fw-bold fs-18-ss d-flex align-items-center px-4 mb-3`}
            aria-current="page">
            <Image
              src={`/img/icon-nav-jadwal-ujian.svg`}
              alt="jadwal ujian"
              className="me-2"
              width={0}
              height={0}
              unoptimized
              priority
              style={{ width: 'auto', height: "auto" }}
            />
            Jadwal Ujian
          </Link>
        </li>
        <li className="nav-item">
          <Link
            href={`${ssURL}/analisis-soal-ujian`}
            className={`nav-link ${activeMenu == `${ssURL}/analisis-soal-ujian` && "active"
              } color-dark fw-bold fs-18-ss d-flex align-items-center px-4 mb-3`}
            aria-current="page">
            <Image
              src={`/img/icon-nav-analisis-soal-ujian.svg`}
              alt="analisis-soal-ujian"
              className="me-2"
              width={0}
              height={0}
              unoptimized
              priority
              style={{ width: 'auto', height: "auto" }}
            />
            Analisis Soal
          </Link>
        </li>
        <li className="nav-item">
          <Link
            href={`${ssURL}/sampah-bank-soal`}
            className={`nav-link ${activeMenu == `${ssURL}/sampah-bank-soal` && "active"
              } color-dark fw-bold fs-18-ss d-flex align-items-center px-4 mb-3`}
            aria-current="page">
            <Image
              src={`/img/icon-nav-daftar-ujian.svg`}
              alt="daftar-ujian"
              className="me-2"
              width={0}
              height={0}
              unoptimized
              priority
              style={{ width: 'auto', height: "auto" }}
            />
            Sampah Bank Soal
          </Link>
        </li>
      </ul>
    </>
  );
};

export default SideBarUjian;
